export default "__VITE_ASSET__CEQhcvxq__"